import type { DocumentSettings } from '@batiflow/contracts';
import { intlLocale } from '@batiflow/i18n';
import { __css, tokens } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { useLocale } from '@/app/providers/i18n-provider';
import { previewCode, type MetadataValues } from './naming-model';

const useStyles = __css({"box":{"mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Belr9w4":"f1j0q4x9","Dbcxam":0,"rjzwhg":0,"Bblux5w":"f9b8bpc","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"f12n3xlw","Beyfa6y":0,"Bbmb7ep":0,"Btl43ni":0,"B7oj6ja":0,"Dimara":"ft85np5","De3pzq":"f1dmdbja"},"label":{"Be2twd7":"fy9rknc","sj55zd":"fkfq4zb"},"code":{"Bahqtrf":"f1fedwem","Be2twd7":"fod5ikn","Bhrd7zp":"fl43uef","Btd35i7":"fjksvth"},"hint":{"Bo78w4l":0,"Cgygva":0,"yil37a":"f8ntp42","Be2twd7":"fy9rknc","sj55zd":"fkfq4zb"}});

export interface CodePreviewProps {
  settings: DocumentSettings;
  projectCode: string | null;
  values: Pick<MetadataValues, 'discipline' | 'phaseType' | 'docType' | 'zone'>;
}

/**
 * The code the organisation's pattern will give, as the metadata are filled in (`###` stands for
 * the sequence number, given when the file is added), or what is still missing for a code.
 */
export function CodePreview({ settings, projectCode, values }: CodePreviewProps) {
  const { t } = useTranslation('documents');
  const styles = useStyles();
  const locale = useLocale();
  const preview = previewCode(settings, projectCode, values);
  const fields = preview.ok
    ? ''
    : new Intl.ListFormat(intlLocale(locale), { style: 'long', type: 'conjunction' }).format(
        preview.missing.map((field) => t(`metadata.fields.${field}`)),
      );
  return (
    <div className={styles.box} aria-live="polite">
      <span className={styles.label}>{t('codePreview.label')}</span>
      {preview.ok ? (
        <>
          <bdi dir="ltr" className={styles.code}>
            {preview.code}
          </bdi>
          <p className={styles.hint}>{t('codePreview.number')}</p>
        </>
      ) : (
        <p className={styles.hint}>{t('codePreview.missing', { fields })}</p>
      )}
    </div>
  );
}


import "/opt/batiflow/app/apps/web/src/features/documents/code-preview.griffel.css";